$(document).on('turbo:load turbo:render multiSelectClicked sponsorRowAdded fieldChange', () => {

    calculateTotalContributions();
    calculateTotalTableContributions();
    calculateTicketContributions();
    calculateSpeakingContributions();
    $(".contribution").each((i , el)=>{
        let $el = $(el);
        $el.on("change", ()=>{
            calculateTotalContributions();
            calculateTotalTableContributions();
        })
    });
    $(".ticket-contribution").each((i , el)=>{
        let $el = $(el);
        $el.on("change", ()=>{
            calculateTicketContributions()
        })
    });
    $(".speaking-contribution").each((i, el)=>{
      let $el = $(el);
        $el.on("change", ()=>{
            calculateSpeakingContributions()
        });
    })

});




function calculateTicketContributions(){
    let total = 0;
    $(".ticket-contribution").each((i , el)=>{
        let $el = $(el);
        if ($el.val() != "") {
            let valueString = ("" + $el.val()).replace(/,/g, '');
            total += parseFloat(valueString)
        }
        let totalString = `${total}`;
        let totalDisplay;
        totalDisplay = "$" + Number(totalString).toFixed(2);

        $(".total-ticket-contribution").html(totalDisplay.replace(/(\.\d{2})\d+/g, '$1'));

    });
}
function calculateSpeakingContributions(){
    let total = 0;
    $(".speaking-contribution").each((i , el)=>{
        let $el = $(el);
        if ($el.val() != "") {
            let valueString = ("" + $el.val()).replace(/,/g, '');
            total += parseFloat(valueString)
        }
        let totalString = `${total}`;
        let totalDisplay;
        totalDisplay = "$" + Number(totalString).toFixed(2);

        $(".total-speaking-contribution").html(totalDisplay.replace(/(\.\d{2})\d+/g, '$1'));

    });
}

function calculateTotalContributions(){
    let total = 0;
    $(".contribution").each((i , el)=>{
        let $el = $(el);
        if ($el.val() != "") {
            let valueString = ("" + $el.val()).replace(/,/g, '');
            total += parseFloat(valueString)
        }
        let totalString = `${total}`;
        let totalDisplay;
        totalDisplay = "$" + Number(totalString).toFixed(2);

        $(".total-contribution").html(totalDisplay.replace(/(\.\d{2})\d+/g, '$1'));

    });
}



function calculateTotalTableContributions(){
    let total =0;
    $(".table-total-contribution").closest("fieldset").find(".contribution").each((i , el)=>{
        let $el = $(el);
        if ($el.val() != "") {
            let valueString = ("" + $el.val()).replace(/,/g, '');
            total += parseFloat(valueString)
        }
        let totalString = `${total}`;
        let totalDisplay;
        totalDisplay = "$" + Number(totalString).toFixed(2);

        $(".table-total-contribution").html(totalDisplay.replace(/(\.\d{2})\d+/g, '$1'));

    })
}

function formatNumber(n) {
    // format number 1000000 to 1,234,567
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}